"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CVCard = void 0;
exports.renderCVSection = renderCVSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("./ResumeSection.css");
var _texts = require("../../texts");
var _ResumeEditDialog = require("./ResumeEditDialog");
var _sectionCardHelpers = require("../shared/sectionCardHelpers");
var _collapsibleSection = require("../shared/collapsibleSection");
var _profileIcons = require("../../icons-svg/profileIcons");
function renderRole(role, index) {
  if (!role) return (0, _litHtml.html)``;
  const roleTitleId = `cv-role-title-${index}`;
  const rolePeriodId = `cv-role-period-${index}`;
  const roleOrgId = `cv-role-org-${index}`;
  const roleDescriptionId = `cv-role-description-${index}`;
  const ariaDescribedBy = role.description ? `${roleOrgId} ${rolePeriodId} ${roleDescriptionId}` : `${roleOrgId} ${rolePeriodId}`;
  return (0, _litHtml.html)`
    <li class="resume-card__item" role="listitem" aria-labelledby=${roleTitleId} aria-describedby=${ariaDescribedBy}>
    <div class="resume-card__item-header">
      <h3 id=${roleTitleId}>${role.title}</h3>
    </div>
    <p class="resume-card__organization" id=${roleOrgId}>
      <strong class="resume-card__organization-name">${role.orgName}</strong>${role.orgLocation ? (0, _litHtml.html)`<span class="resume-card__organization-separator" aria-hidden="true"> | </span><span class="resume-card__organization-location">${role.orgLocation}</span>` : ''}
    </p>
    <p id=${rolePeriodId} class="resume-card__item-period">
      <time datetime=${(0, _sectionCardHelpers.toMonthDateTime)(role.startDate)}>${(0, _sectionCardHelpers.formatMonthYear)(role.startDate)}</time>
      <span> to </span>
      ${role.endDate ? (0, _litHtml.html)`<time datetime=${(0, _sectionCardHelpers.toMonthDateTime)(role.endDate)}>${(0, _sectionCardHelpers.formatMonthYear)(role.endDate)}</time>` : (0, _litHtml.html)`<span>Present</span>`}
    </p>
    ${role.description ? (0, _litHtml.html)`
      <div class="resume-card__description-wrap">
        <p class="resume-card__description-text" id=${roleDescriptionId}>${role.description}</p>
        <solid-ui-button
          type="button"
          variant="secondary"
          size="sm"
          label="...more"
          class="resume-card__description-toggle"
          aria-controls=${roleDescriptionId}
          aria-expanded="false"
          hidden
          @click=${_sectionCardHelpers.toggleDescription}
        >
          ...more
        </solid-ui-button>
      </div>
    ` : ''}
    </li>
  `;
}
function renderRoles(roles) {
  if (!roles || !roles.length) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`${roles.map((role, index) => renderRole(role, index))}`;
}
const CVCard = (cvData, _viewerMode) => {
  const hasRoles = Array.isArray(cvData) && cvData.length > 0;
  if (!hasRoles) return (0, _litHtml.html)``;
  return (0, _litHtml.html)`
    <article class="resume-card" aria-label="Resume" data-testid="curriculum-vitae">
      <section class="resume-card__section">
        <ul role="list" aria-label="Work experience in chronological order">
          ${renderRoles(cvData)}
        </ul>
      </section>
    </article>
  `;
};
exports.CVCard = CVCard;
function renderResumeSectionDefault(store, subject, resumeDetails, viewerMode, onSaved) {
  (0, _sectionCardHelpers.scheduleDescriptionOverflowCheck)();
  const hasResume = resumeDetails.length > 0;
  const showSection = true;
  const cv = hasResume ? CVCard(resumeDetails, viewerMode) : (0, _litHtml.html)``;
  const isOwner = viewerMode === 'owner';
  return showSection ? (0, _litHtml.html)`
    <section 
      aria-labelledby="cv-heading" 
      data-profile-section="resume"
      class="profile__section profile-section-collapsible profile-section-collapsible--inline-mobile-actions" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="cv-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
        <div class="profile-section-collapsible__actions">
          ${isOwner ? (0, _litHtml.html)`
            <solid-ui-button
              type="button"
              variant="secondary"
              size="sm"
              class="profile__action-button resume__edit-button profile-section-collapsible__edit-button"
              aria-label="Edit resume details"
              @click=${event => (0, _ResumeEditDialog.createResumeEditDialog)(event, store, subject, resumeDetails, viewerMode, onSaved)}
            >
              <span class="profile-section-collapsible__edit-label">${_profileIcons.editIcon} Edit</span>
              <span class="profile-section-collapsible__edit-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
            </solid-ui-button>
          ` : (0, _litHtml.html)``}
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle resume section"
            aria-controls="cv-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="cv-panel" class="profile-section-collapsible__content">
        ${hasResume ? cv : (0, _litHtml.html)`<p>No resume details added yet.</p>`}
      </div>
    </section>
  ` : '';
}
function renderOwnerEmptyResumeContent(store, subject, resumeDetails, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <div class="profile__empty-state-content" role="group" aria-label="Empty resume section">
      <h2 id="resume-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
      <p class="profile__empty-state-message">
        You haven't included any professional experience yet. Consider adding your work history to enhance your resume.
      </p>
    </div>
    <solid-ui-button
      type="button"
      variant="secondary"
      size="sm"
      class="profile__action-button--empty"
      @click=${event => {
    return (0, _ResumeEditDialog.createResumeEditDialog)(event, store, subject, resumeDetails, viewerMode, onSaved);
  }}
    >
      <span class="profile__action-icon" aria-hidden="true">${_profileIcons.plusDarkIcon} Add Resume</span>
    </solid-ui-button>

  `;
}
function renderOwnerEmptyResumeSection(store, subject, resumeDetails, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section
      aria-labelledby="resume-heading" 
      data-profile-section="resume"
      class="profile__section--empty profile__section--empty-main profile-section-collapsible profile-section-collapsible--inline-mobile-actions profile-section-collapsible--empty-mobile-no-edit" 
      role="region"
      tabindex="-1"
      data-expanded="false"
    >
      <header class="profile__section-header profile-section-collapsible__header">
        <h2 id="resume-heading" tabindex="-1">${_texts.resumeHeadingText}</h2>
        <div class="profile-section-collapsible__actions">
          <solid-ui-button
            type="button"
            variant="icon"
            size="sm"
            class="profile-section-collapsible__toggle-button"
            aria-label="Toggle resume section"
            aria-controls="cv-panel"
            aria-expanded="false"
            @click=${_collapsibleSection.toggleCollapsibleSection}
          >
            <span slot="icon" class="profile-section-collapsible__chevron" aria-hidden="true">${_profileIcons.chevronDownIcon}</span>
          </solid-ui-button>
        </div>
      </header>
      <div id="cv-panel" class="profile-section-collapsible__content">
        ${renderOwnerEmptyResumeContent(store, subject, resumeDetails, viewerMode, onSaved)}
      </div>
    </section>
  `;
}
function renderCVSection(store, subject, roles, viewerMode, onSaved) {
  const resumeDetails = roles || [];
  const hasResume = resumeDetails.length > 0;
  const showOwnerEmptyResume = !hasResume && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyResume ? renderOwnerEmptyResumeSection(store, subject, resumeDetails, viewerMode, onSaved) : renderResumeSectionDefault(store, subject, resumeDetails, viewerMode, onSaved)}
  ` : '';
}